<template>
  <div class="is-max-height-500 is-overflow-auto">
    <transition  enter-active-class="animated fadeIn veryFastAnimation" leave-active-class="animated fadeOut veryFastAnimation" mode="out-in">
      <div key="events-" v-if="showList && events.length > 0" class="">
        <event-tracker v-for="(event, idx) in events" :key="idx" :event="event" :show-icon="false"
                      :has-click-event="idx === 0" class="veryFastAnimation"
                      @onClick="toggleList" :is-last="idx === events.length - 1"
                      :is-open="showList === true" :classes="classes">
        </event-tracker><!-- :show-icon="idx===0" -->
      </div>
      <div key="event" v-else-if="lastEvent" class="">
        <event-tracker :event="lastEvent" :show-icon="false" :has-click-event="events.length > 1"
                      @onClick="toggleList" :is-last="true" class=""></event-tracker>
      </div>
    </transition>
    <div class="has-cursor-pointer columns is-vcentered has-bg-light is-border-right is-border-bottom is-border-left"
          v-if="showList && !showAll">
      <div @click="$emit('showAll')" class="column is-padding-top-xsmall is-padding-bottom-xsmall" style="padding-left: 4px; padding-right: 4px; word-break: break-all;">
        <div class="truncate">
          <div class="is-size-6 has-text-grey has-text-centered is-underline">
            Voir tout l'historique
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EventTrackerList',
    props: {
      events: {
        type: Array,
        required: false
      },
      classes: {
        type: [Array, String],
        required: false
      },
      lastEvent: {
        type: Object,
        required: false
      },
      showList: {
        type: Boolean,
        required: true,
        default: false
      },
      showAll: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      toggleList () {
        this.$emit('toggle')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/EventTrackerList.vue